import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _get from '@babel/runtime/helpers/get';
import _inherits from '@babel/runtime/helpers/inherits';
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function (r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {
        }));
    } catch (t) {
    }
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _superPropGet(t, o, e, r) {
    var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
    return 2 & r && 'function' == typeof p ? function (t) {
        return p.apply(e, t);
    } : p;
}
import _ from 'lodash';
import DPlayer from '../core/index';
import PictureInPicture from '../core/picture-in-picture';
import utils from '../core/utils';
import Monitor from './monitor';
import Feedback from './feedback';
import EndPanel from './endpanel';
import TurnOffLight from './turn-off-light';
import MiniPlayer from './miniplayer';
import KeyboardForbidden from './forbidden';
import Interaction from './interaction';
import EventEmitter from './event-emitter';
import handlerUserInfoOptions from './options';
var MtPlayer = function (_DPlayer) {
    function MtPlayer(options) {
        var _this;
        _classCallCheck(this, MtPlayer);
        _this = _callSuper(this, MtPlayer, [options]);
        _this.hasLoaded = false;
        _this.pauseStart = 0;
        _this.replayCount = 0;
        if (!utils.isMobileOrElectron && options.pictureinpicture) {
            _this.pictureInPicture = new PictureInPicture(_this);
        }
        _this.userInfo = handlerUserInfoOptions(options.userInfo);
        _this.socket = options.socket;
        if (_this.socket) {
            _this.monitor = new Monitor(_this);
        }
        if (options.feedback) {
            _this.feedback = new Feedback(_this);
        }
        if (options.endpanel) {
            _this.endPanel = new EndPanel(_this);
        }
        if (options.light) {
            _this.turnOffLight = new TurnOffLight(_this);
        }
        _this.forbidden = new KeyboardForbidden(_this);
        if (options.highlight) {
            _this.interaction = new Interaction(_this);
        }
        if (options.miniPlayer) {
            _this.miniPlayer = new MiniPlayer(_this);
        }
        if (options.collection) {
        }
        _this.emitter = new EventEmitter(_this);
        _this.startTime = Date.now();
        _this.startPlayTime = 0;
        _this.bufferTime = 0;
        _this.loadedTime = 0;
        _this.isFirstPlay = true;
        _this.waitingTimer = null;
        _this.startWaitingTime = Date.now();
        _this.startSwitchCDNTime = 0;
        _this.hasEmitInit = false;
        _this.cdnSeedOkDur = 0;
        _this.startWaitingTimer();
        _this.initSeekWarning();
        _this.initEvents();
        _this.initPlaybackRatesButton();
        return _this;
    }
    _inherits(MtPlayer, _DPlayer);
    return _createClass(MtPlayer, [
        {
            key: 'startWaitingTimer',
            value: function startWaitingTimer() {
                var _this2 = this;
                this.waitingTimer = setInterval(function () {
                    if (_this2.video.readyState > 3 || _this2.video.paused) {
                        _this2.startWaitingTime = null;
                        return;
                    }
                    if (!_this2.startWaitingTime) {
                        _this2.startWaitingTime = Date.now();
                    }
                    if (_this2.emitter.currentEventName !== 'VIDEO_BLOCK') {
                        _this2.emitter.emit('VIDEO_BLOCK');
                    }
                    if (Date.now() - _this2.startWaitingTime >= 4000) {
                        _this2.startWaitingTime = Date.now();
                        _this2.switchToNextCDN();
                    }
                }, 2000);
            }
        },
        {
            key: 'initPlaybackRatesButton',
            value: function initPlaybackRatesButton() {
                var _this3 = this;
                if (this.options.playbackRates) {
                    this.template.playbackRate.addEventListener('click', function (e) {
                        if (e.target.classList.contains('dplayer-playback-item')) {
                            var rate = e.target.dataset.index;
                            Array.prototype.slice.call(_this3.template.playbackItem).forEach(function (item, i) {
                                if (item.classList.contains('dplayer-playback-active')) {
                                    item.classList.remove('dplayer-playback-active');
                                }
                            });
                            e.target.classList.add('dplayer-playback-active');
                            _this3.speed(rate);
                            _this3.template.playbackRateButton.innerHTML = ''.concat(rate, 'X');
                        }
                    });
                }
            }
        },
        {
            key: 'initEvents',
            value: function initEvents() {
                var _this4 = this;
                this.on('durationchange', function () {
                    if (typeof _this4.video.duration === 'number') {
                        _this4.emitter.commonParam.sourceTime = _this4.video.duration.toFixed(2);
                    }
                    var volume = localStorage.getItem('dplayer-volume') || 0;
                    if (!_this4.hasEmitInit) {
                        _this4.hasEmitInit = true;
                        _this4.emitter.emit('VIDEO_INIT', {
                            volume: volume || _this4.options.volume || 0.7,
                            resolution: _.get(_this4.options, 'video.quality.'.concat(_.get(_this4.options.video, 'defaultQuality'), '.name'), ''),
                            rate: _this4.video.playbackRate || 1
                        });
                    }
                });
                this.on('canplay', function () {
                    _this4.hasLoaded = true;
                    var now = Date.now();
                    _this4.loadedTime = now;
                    _this4.bufferTime = now - _this4.startTime;
                    _this4.cdnSeedOkDur = _this4.startSwitchCDNTime;
                    if (_this4.isFirstPlay) {
                        _this4.emitter.emit('VIDEO_SUCCESSFUL', {
                            cdnSeedCount: _this4.options.video.defaultCdn,
                            cdnSeedOkDur: _this4.cdnSeedOkDur,
                            bufferTime: _this4.bufferTime
                        });
                    }
                    if (!_this4.video.paused && _this4.isFirstPlay) {
                        _this4.isFirstPlay = false;
                        _this4.emitter.emit('VIDEO_PLAY', {
                            cdnSeedCount: _this4.options.video.defaultCdn,
                            cdnSeedOkDur: _this4.cdnSeedOkDur,
                            bufferTime: _this4.bufferTime
                        });
                        _this4.startHeartBeat();
                    }
                    if (_this4.startWaitingTime) {
                        var blockDuration = Date.now() - _this4.startWaitingTime;
                        _this4.startWaitingTime = null;
                        _this4.emitter.emit('VIDEO_ENDBLOCK', { bufferTime: blockDuration });
                    }
                });
                this.on('ended', function () {
                    _this4.emitter.emit('VIDEO_END');
                });
                this.on('replay', function () {
                    _this4.emitter.emit('VIDEO_REPLAY', { replayCount: ++_this4.replayCount });
                });
                this.on('forward', function (_ref) {
                    var startTime = _ref.startTime, endTime = _ref.endTime;
                    _this4.emitter.emit('VIDEO_FORWARD', {
                        startDragPos: startTime,
                        endDragPos: endTime
                    });
                });
                this.on('backward', function (_ref2) {
                    var startTime = _ref2.startTime, endTime = _ref2.endTime;
                    _this4.emitter.emit('VIDEO_BACKWARD', {
                        startDragPos: startTime,
                        endDragPos: endTime
                    });
                });
                this.on('screenshot', function (s) {
                    _this4.emitter.emit('VIDEO_SCREENSHOT', { screenshotState: s ? 'OK' : 'NO' });
                });
                this.on('volumeVary', _.debounce(function (info) {
                    _this4.emitter.emit('VIDEO_VOLUME', info);
                }, 300));
                this.on('resolutionChange', function (info) {
                    _this4.emitter.emit('VIDEO_RESOLUTION', _objectSpread(_objectSpread({}, info), {}, {
                        cdnSeedCount: _this4.options.video.defaultCdn,
                        cdnSeedOkDur: _this4.cdnSeedOkDur
                    }));
                });
                this.on('rateVary', function (info) {
                    _this4.emitter.emit('VIDEO_RATE', info);
                });
                this.on('fullscreen', function () {
                    _this4.emitter.emit('VIDEO_OPENFULL');
                });
                this.on('fullscreen_cancel', function () {
                    _this4.emitter.emit('VIDEO_ENDFULL');
                });
                this.on('openPicture', function () {
                    _this4.emitter.emit('VIDEO_OPENPICTURE');
                });
                this.on('endPicture', function () {
                    _this4.emitter.emit('VIDEO_ENDPICTURE');
                });
                this.on('turnOff', function () {
                    _this4.emitter.emit('VIDEO_OFFTURN');
                });
                this.on('turnOn', function () {
                    _this4.emitter.emit('VIDEO_ONTURN');
                });
                this.on('error', function () {
                    var isSPAD = /SPAD/.test(navigator.userAgent);
                    if (!isSPAD) {
                        _this4.switchToNextCDN();
                    }
                });
            }
        },
        {
            key: 'initSeekWarning',
            value: function initSeekWarning() {
                var _this5 = this;
                if (this.monitor) {
                    return;
                }
                var startTime = 0, endTime = 0;
                var _thumbUp = function thumbUp() {
                    var event = '';
                    document.removeEventListener(utils.nameMap.dragEnd, _thumbUp);
                    endTime = _this5.video.currentTime;
                    if (startTime < endTime) {
                        event = 'forward';
                    } else {
                        event = 'backward';
                    }
                    _this5.events.trigger(event, {
                        startTime: startTime,
                        endTime: endTime
                    });
                };
                if (!this.options.disableBar) {
                    this.template.playedBarWrap.addEventListener(utils.nameMap.dragStart, function () {
                        startTime = _this5.video.currentTime;
                        document.addEventListener(utils.nameMap.dragEnd, _thumbUp);
                    });
                }
            }
        },
        {
            key: 'pause',
            value: function pause(type) {
                _superPropGet(MtPlayer, 'pause', this, 3)([type]);
                this.pauseStart = Date.now();
            }
        },
        {
            key: 'switchToNextCDN',
            value: function switchToNextCDN() {
                var cdn = this.options.video.cdn;
                var trueVideoUri;
                if (cdn) {
                    var routeNum = this.options.video.defaultCdn;
                    if (routeNum < this.options.video.cdn.length - 1) {
                        var isSPAD = /SPAD/.test(navigator.userAgent);
                        if (!isSPAD) {
                            routeNum++;
                        }
                        var prevUrl = this.options.video.url;
                        this.options.video.defaultCdn++;
                        trueVideoUri = (window.location.protocol === 'https:' ? 'https:' : 'http:') + this.options.video.cdn[routeNum] + this.options.video.uri;
                        this.options.video = this.handleVideoData(this.options.video, trueVideoUri, routeNum);
                        if (this.options.video.quality) {
                            this.options.video.url = this.options.video.quality[this.qualityIndex].url;
                        }
                        this.emitter.emit('VIDEO_FAILED', {
                            cdnSeedCount: routeNum,
                            cdnSeedOkDur: this.cdnSeedOkDur,
                            bufferTime: Date.now() - this.startTime,
                            errorSourceUrl: prevUrl,
                            nextSourceUrl: this.options.video.url,
                            sourceUrl: this.options.video.url
                        });
                        this.switchVideo({ url: this.options.video.url || this.video.src });
                        this.startTime = Date.now();
                        this.startSwitchCDNTime = Date.now();
                    } else {
                        this.emitter.emit('VIDEO_ERROR', {
                            cdnSeedCount: routeNum,
                            cdnSeedOkDur: Date.now(),
                            bufferTime: -1,
                            sourceUrl: this.options.video.url
                        });
                    }
                } else {
                    this.emitter.emit('VIDEO_ERROR', {
                        cdnSeedCount: 0,
                        cdnSeedOkDur: 0,
                        bufferTime: -1,
                        sourceUrl: this.options.video.url
                    });
                }
            }
        },
        {
            key: 'handleVideoData',
            value: function handleVideoData(tranUrlData, trueVideoUri, routeNum) {
                return {
                    quality: [
                        {
                            name: '标清480P',
                            text: '标清',
                            url: ''.concat(trueVideoUri, '_480.m3u8')
                        },
                        {
                            name: '高清720P',
                            text: '高清',
                            url: ''.concat(trueVideoUri, '_720.m3u8')
                        },
                        {
                            name: '超清1080P',
                            text: '超清',
                            url: ''.concat(trueVideoUri, '_1080.m3u8')
                        }
                    ],
                    defaultQuality: utils.isDingDing || utils.isSSAI ? 0 : 1,
                    uri: tranUrlData.uri,
                    cdn: tranUrlData.cdn,
                    defaultCdn: routeNum,
                    pic: 'https://file1-tx.classba.cn/homepage.png'
                };
            }
        },
        {
            key: 'play',
            value: function play() {
                _superPropGet(MtPlayer, 'play', this, 3)([]);
                if (this.hasLoaded && this.isFirstPlay) {
                    this.isFirstPlay = false;
                    this.startPlayTime = Date.now();
                    this.emitter.emit('VIDEO_PLAY', {
                        cdnSeedCount: this.options.video.defaultCdn,
                        cdnSeedOkDur: this.cdnSeedOkDur,
                        bufferTime: this.bufferTime
                    });
                    this.startHeartBeat();
                } else if (this.hasLoaded && this.pauseStart) {
                    this.emitter.emit('VIDEO_RESUME', { pauseTime: this.toSecond(Date.now() - this.pauseStart) });
                    this.startHeartBeat();
                    this.pauseStart = null;
                }
            }
        },
        {
            key: 'toSecond',
            value: function toSecond(ms) {
                return ((ms || 0) / 1000).toFixed(2);
            }
        },
        {
            key: 'startHeartBeat',
            value: function startHeartBeat() {
                var _this6 = this;
                if (this.heartTimer) {
                    return;
                }
                this.heartTimer = setInterval(function () {
                    _this6.emitter.emit('VIDEO_HEARBEAT', {
                        currentEvent: _this6.emitter.currentEventName,
                        currentEventTime: _this6.toSecond(Date.now() - (_this6.emitter.currentEventStart || Date.now()))
                    });
                }, 5000);
            }
        },
        {
            key: 'stopHeartBeat',
            value: function stopHeartBeat() {
                clearInterval(this.heartTimer);
                this.heartTimer = null;
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                var _this7 = this;
                if (this.container.innerHTML !== '') {
                    this.pause('AT');
                    this.emitter.emit('VIDEO_CLOSE', {});
                    _superPropGet(MtPlayer, 'destroy', this, 3)([]);
                    this.emitter.destroy();
                    this.stopHeartBeat();
                    clearInterval(this.waitingTimer);
                    Object.keys(this.events.events).forEach(function (key) {
                        _this7.off(key);
                    });
                }
            }
        },
        {
            key: 'closeDot',
            value: function closeDot() {
                this.emitter.emit('VIDEO_CLOSE', {});
                this.stopHeartBeat();
            }
        }
    ]);
}(DPlayer);
export default MtPlayer;